import { combineReducers } from 'redux';

// Slices

import utils from './slices/utils';
import { homeReducer } from './slices/home';
import { qualificationReducer } from './slices/qualification';
import { newsReducer } from './slices/news';
import { documentReducer } from './slices/document';
import { equivalenceReducer } from './slices/equivalence';

const rootReducer = combineReducers({
  utils: utils,
  home: homeReducer,
  qualification: qualificationReducer,
  news: newsReducer,
  document: documentReducer,
  equivalence: equivalenceReducer,
});

export default rootReducer;
